export enum RegionTaxRateStatus {
  Active = 1,
  Scheduled = 2,
  Cancelled = 3,
  Past = 4
}
